import "../../stylesheets/App.css";
import React, { useState, useEffect } from "react";
import GameAdmin from "./GameAdmin.js";
import Groups from "./Groups.js";
import PopupAdminStages from "./PopupAdminStages.js";
import Loader from "./Loader.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

function AdminStageModule() {
  const [loadingStages, setLoadingStages] = useState(true);
  const [loadingTeamList, setLoadingTeamList] = useState(true);
  const [loadingUpdateStages, setLoadingUpdateStages] = useState(false);

  const [stages, setStages] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [openStagePopup, setOpenStagePopup] = useState(-1);
  const [refresh, setRefresh] = useState(false);

  const apiCall = (url, consecuencia) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => consecuencia(data))
      .catch((error) => console.log(error));
  };

  const updateStages = (data) => {
    setStages(data.data || []);
    setLoadingStages(false);
  };

  const updateTeamList = (data) => {
    setTeamList(data.data || []);
    setLoadingTeamList(false);
  };

  useEffect(() => {
    apiCall(process.env.REACT_APP_API_BASE_URL + "/admin/teamsList", updateTeamList);
  }, []);

  useEffect(() => {
    setLoadingStages(true);
    apiCall(
      process.env.REACT_APP_API_BASE_URL + "/admin/stagesListWithGames",
      updateStages
    );
    setRefresh(false);
  }, [refresh]);

  const showTeams = (i) => {
    const list = document.getElementById("adminlist-" + i);
    const icon = document.getElementById("adminicon-" + i);
    if (list) list.classList.toggle("active");
    if (icon) icon.classList.toggle("active");
  };

  const updateStage = async (i) => {
    if (!stages[i]) return;

    if (stages[i].active === 1) {
      setOpenStagePopup(i);
      return;
    }

    setLoadingUpdateStages(true);
    try {
      let result = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/admin/enableStage/${stages[i].idStage}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      ).then((r) => r.json());

      if (result.status == 200) {
        setStages((prev) =>
          prev.map((s, idx) => (idx === i ? { ...s, active: 1 } : s))
        );
      } else {
        alert("Error al activar fase");
      }
    } catch (e) {
      console.log(e);
      alert("Error al activar fase");
    } finally {
      setLoadingUpdateStages(false);
    }
  };

  const deactivateStage = async (i) => {
    setOpenStagePopup(-1);
    if (!stages[i]) return;

    setLoadingUpdateStages(true);
    try {
      let result = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/admin/disableStage/${stages[i].idStage}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      ).then((r) => r.json());

      if (result.status == 200) {
        setStages((prev) =>
          prev.map((s, idx) => (idx === i ? { ...s, active: 0 } : s))
        );
      } else {
        alert("Error al desactivar fase");
      }
    } catch (e) {
      console.log(e);
      alert("Error al desactivar fase");
    } finally {
      setLoadingUpdateStages(false);
    }
  };

  return (
    <>
      <section className="admin-stages-section">
        <div className="subtitles container-subtitles">
          <div>Programar partidos</div>
          <div>Activar fase</div>
        </div>

        <ul>
          {stages.map((stage, i) => (
            <li key={"item-" + stage.idStage}>
              <div className="li-container">
                <div
                  className="score-stage-title-container"
                  onClick={() => showTeams(i)}
                >
                  <h1>{stage.name}</h1>
                  <div className={"stage-icon"} id={"adminicon-" + i}>
                    <FontAwesomeIcon icon={solid("chevron-down")} />
                  </div>
                </div>

                <div
                  className={stage.active == 1 ? "score-activador active" : "score-activador"}
                  id={"activador-" + i}
                  onClick={() => updateStage(i)}
                >
                  <div className="ball"></div>
                </div>
              </div>

              <div id={"adminlist-" + i} className="teams-by-stage-list">
                <ul>
                  {stage.idStage == 1 ? (
                    <Groups admin={true} teamList={teamList} />
                  ) : (
                    (stage.games || []).map((game) => (
                      <li key={"li_" + game.idGame}>
                        <GameAdmin
                          key={game.idGame}
                          data={game}
                          teamList={teamList}
                          setRefresh={setRefresh}
                        />
                      </li>
                    ))
                  )}
                </ul>
              </div>
            </li>
          ))}
        </ul>

        {openStagePopup != -1 ? (
          <PopupAdminStages
            setLoadingUpdateStages={setLoadingUpdateStages}
            title="¿Desactivar fase?"
            text="Al desactivar la fase se elimina la posibilidad de pronosticar"
            action={() => deactivateStage(openStagePopup)}
            closeAction={setOpenStagePopup}
            closeValue={-1}
          />
        ) : null}
      </section>

      {(loadingStages || loadingTeamList || loadingUpdateStages) ? <Loader /> : null}
    </>
  );
}

export default AdminStageModule;
